<template>
  <html>
    <MenuApp />
    <div class="container">
      <h1>Paiement Validé</h1>
      <p>
        Félicitations ! Votre paiement a été validé avec succès. Votre document
        est en cours d'impression
      </p>
    </div>
  </html>
</template>

<script>
import MenuApp from "./MenuApp.vue";
export default {
  name: "PaymentsValidated",
  components: { MenuApp },
};
</script>

<style scoped>
.page {
  text-align: center;
  padding: 20px;
}
</style>
